import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { GuideData, GuidePreview, PlainDoc, Voice } from "../../core/types/guide"
import {Guide, VideoClip} from '../../core/types/guide';
import { RootState } from '../store';
import { GigaUserApi } from "@giga-user-fern/api";
import logger from "../../utils/logger";
import { VideoMetadata } from "@giga-user-fern/api/types/api/resources/guides";

type GuideInput = {
    guidePreview: GuidePreview, 
    guideData: GuideData,
}

interface GuideState {
    value: {
        guide?:Guide
    }
}

const initialState: GuideState = {
    value: {
        guide: undefined
    }
}

export const defaultVoice: Voice = {
    engine: "play", 
    code: "s3://peregrine-voices/donna_parrot_saad/manifest.json",
    language: "en-US"
}

export const guideSlice = createSlice({
    name: 'guide', 
    initialState,
    reducers: {

        setGuideLoading: (state) =>{
            state.value.guide = undefined
        },

        setGuide: (state, action:PayloadAction<Guide> ) =>{
            const guide = action.payload
            state.value.guide = guide
        },

        setGuidePreview: (state, action:PayloadAction<GuidePreview> ) =>{
            //@ts-expect-error
            state.value.guide.guidePreview = action.payload
        },

        setGeneratedSrc:(state, action:PayloadAction<VideoMetadata> ) =>{
            const newMetadata = action.payload
            if(state.value.guide?.guideData.video.metadata.generatedVideo){
                state.value.guide.guideData.video.metadata.generatedVideo.src = newMetadata.generatedVideo?.src
            }
            if(state.value.guide?.guideData.video.metadata.decoratedAiVideo){
                state.value.guide.guideData.video.metadata.decoratedAiVideo.src = newMetadata.decoratedAiVideo?.src
            }
        },
        
        setVideoTranscript: (state, action: PayloadAction<PlainDoc>)=>{
            const newDoc = action.payload
            //@ts-expect-error
            state.value.guide.guideData.video.metadata.generatedVideo.transcript = newDoc
        },
        setPlainDoc: (state, action: PayloadAction<PlainDoc>)=>{
            const newDoc = action.payload
            //@ts-expect-error
            state.value.guide.guideData.plainDoc = newDoc
        },
        setTitle: (state, action: PayloadAction<string>)=>{
            //@ts-expect-error
            state.value.guide.guidePreview.header.name = action.payload
        },
        setClips: (state, action: PayloadAction<VideoClip[]>) =>{
            logger.debug("trying to setClips ho: ",action.payload)
            
            if(!state.value.guide) return
            state.value.guide.guidePreview.ogVideoClips = action.payload
        },
        setDescription: (state, action: PayloadAction<string>)=>{
            //@ts-expect-error
            state.value.guide.guidePreview.header.description = action.payload
        },
        setGeneratedVideoExists: (state, action: PayloadAction<boolean>)=>{
            //@ts-expect-error
            state.value.guide.guidePreview.generatedVideoExists = action.payload
        },
        setDecoratedAiVideoExists: (state, action: PayloadAction<boolean>)=>{
            //@ts-expect-error
            state.value.guide.guidePreview.decoratedAiVideoExists = action.payload
        },

        setEditedVideoExists: (state, action: PayloadAction<boolean>)=>{
            //@ts-expect-error
            state.value.guide.guidePreview.editedVideoExists = action.payload
        },
        setLoadingGeneratedVideo:(state, action: PayloadAction<boolean>)=>{
            //@ts-expect-error
            state.value.guide.guidePreview.loadingGeneratedVideo = action.payload
        },
        setVoice: (state, action: PayloadAction<Voice | undefined>) =>{

            const voice = action.payload || defaultVoice
            if(state.value.guide) state.value.guide.guidePreview.voice = voice
        }, 

        setGeneralSettings: (state, action: PayloadAction<GuidePreview>) =>{

            const newGuidePreview = action.payload
            if(state.value.guide){
                state.value.guide.guidePreview.header.published = newGuidePreview.header.published
                state.value.guide.guidePreview.hideArticle =  newGuidePreview.hideArticle
                state.value.guide.guidePreview.publishedVideo = newGuidePreview.publishedVideo
            }

        },

        setBookends: (state, action: PayloadAction<{intro_cover?: boolean, main_background?: boolean, outro_cover?: boolean}>) => {
            
            const {intro_cover, main_background, outro_cover} = action.payload

            if(state.value.guide) {
                if(intro_cover !== undefined) state.value.guide.guidePreview.introCover = intro_cover
                if(main_background !== undefined) state.value.guide.guidePreview.mainBackground = main_background
                if(outro_cover !== undefined) state.value.guide.guidePreview.outroCover = outro_cover
            }

        }
        
    }
})

export const {setGuide, setClips, setDecoratedAiVideoExists, setGeneralSettings, setGuidePreview, setEditedVideoExists, setGuideLoading, setBookends, setGeneratedSrc, setVoice, setVideoTranscript, setPlainDoc, setTitle, setDescription, setGeneratedVideoExists, setLoadingGeneratedVideo} = guideSlice.actions

export const selectVideo =  (state: RootState) => state.guide.value.guide?.guideData.video
export const selectClips = (state: RootState) => {
    const clips = state.guide.value.guide?.guidePreview.ogVideoClips

    return clips
    // if(clips) {
    //     return clips
    // }
    // else{
    //     logger.debug("no clips")
    //     return [{startTime: 0, endTime: 0}]
    // }

}
export const selectGuide = (state: RootState) => state.guide.value.guide
export const selectGuidePreview = (state: RootState) => state.guide.value.guide?.guidePreview
export const selectPlainDoc = (state: RootState) => state.guide.value.guide?.guideData.plainDoc
export const selectVoice = (state: RootState) => state.guide.value.guide?.guidePreview.voice || defaultVoice
export const selectVideoTranscript = (state: RootState) => state.guide.value.guide?.guideData.video.metadata?.generatedVideo?.transcript
export const selectLoadingGeneratedVideo = (state: RootState) => state.guide.value.guide?.guidePreview.loadingGeneratedVideo
// Other code such as selectors can use the imported `RootState` type
export default guideSlice.reducer


